export const getAvatarInitial = (name: string) => {
  const initialList = name.split(' ').map(word => word[0]);
  return [
    initialList[0],
    initialList[initialList.length > 1 ? initialList.length - 1 : 1],
  ]
    .filter(Boolean)
    .join('')
    .toUpperCase();
};
